import React from "react";
import { StyledEngineProvider } from "@mui/material/styles";
import {
  Box,
} from "@mui/material";
import SoundAndVibration from "./SoundAndVibration";
import { BrowserRouter  } from "react-router-dom";





function App({fetchAPI}) {

  return (
    <div className="App">
      <StyledEngineProvider injectFirst>
        <BrowserRouter>
          <Box>
           <SoundAndVibration fetchAPI={fetchAPI} />
          </Box>
          </BrowserRouter>
      </StyledEngineProvider>
    </div>
  );
}

export default App;
